import API from './base';

class TheoryAccessProvidersReviewsApi extends API {
  getReviews = (providerId, page = 1, limit = 7) => this.get(`/api/web/v1/theory_access_providers/${providerId}/reviews?limit=${limit}&page=${page}`);

  postReview = (providerId, payload) => this.post(`/api/web/v1/theory_access_providers/${providerId}/reviews`, payload);
}

export default new TheoryAccessProvidersReviewsApi();
